/**
 * Pantalla de acceso: email + contrasena, con error visible y estado de carga.
 */
import { useState } from 'react';
import type { FormEvent, ReactElement } from 'react';
import { Field, Spinner } from './Feedback.tsx';
import { Icon } from './Icon.tsx';

export function LoginScreen({
  onSubmit,
  submitting,
  error,
}: {
  onSubmit: (email: string, password: string) => void;
  submitting: boolean;
  error: string | null;
}): ReactElement {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    const cleanEmail = email.trim();
    if (!cleanEmail || !password) {
      setLocalError('Escribe tu correo y tu contrasena.');
      return;
    }
    setLocalError(null);
    onSubmit(cleanEmail, password);
  };

  const message = localError ?? error;

  return (
    <div className="login">
      <div className="login__card">
        <div className="login__brand">
          <span className="login__logo">WA</span>
          <div>
            <h1 className="login__title">Panel de atencion</h1>
            <p className="login__subtitle">WhatsApp Cloud API</p>
          </div>
        </div>

        <p className="login__intro">
          Accede con tu cuenta de agente para ver la bandeja compartida, las metricas y la
          configuracion del asistente de IA.
        </p>

        {message ? (
          <div className="banner banner--error" role="alert">
            <Icon name="error" className="banner__icon" />
            <p className="banner__text">{message}</p>
          </div>
        ) : null}

        <form className="login__form" onSubmit={handleSubmit} noValidate>
          <Field label="Correo electronico" htmlFor="login-email" required>
            <input
              id="login-email"
              className="input"
              type="email"
              name="email"
              autoComplete="username"
              placeholder="agente@empresa.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              disabled={submitting}
            />
          </Field>

          <Field label="Contrasena" htmlFor="login-password" required>
            <input
              id="login-password"
              className="input"
              type="password"
              name="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              disabled={submitting}
            />
          </Field>

          <button type="submit" className="button button--primary button--block" disabled={submitting}>
            {submitting ? <Spinner label="Entrando…" /> : 'Entrar'}
          </button>
        </form>

        <p className="login__hint">
          La API debe estar en marcha en <code>http://localhost:3000</code>. Si el panel no
          conecta, revisa que el backend y la base de datos esten levantados.
        </p>
      </div>
    </div>
  );
}
